export default __webpack_public_path__ + "static/media/fMaltoBuza24.620b1ccc.png";